module.exports = __webpack_public_path__ + "img/prenotazioni_edit.99bb07fa.png";